export const KEYBOARD_CODE = {
  BACKSPACE: 8,
  ESCAPE: 27,
}
